var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('request-balance', {
    attrs: {
      "on-create": _vm.createRequest,
      "on-search-companies": _vm.searchCompaniesByName,
      "on-fetch-company-details": _vm.handleFetchCompany,
      "company": _vm.company,
      "total": _vm.total
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-299ebd79","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requestBalance/RequestBalanceContainer.vue
// module id = 1125
// module chunks = 0